import axios from "../index";

// 接口基础路径
const rootApi = "/api_v2/production/productionOrder";

/**吹膜页面接口 */
export const deviceOrderPage = (params) => {
  return axios.post(`${rootApi}/deviceOrderPage`, params, {
    dataType: "json",
  });
};
/**吹膜完工页面接口 */
export const getCompletedWordOrder = (params) => {
  return axios.post(`/api_v2/production/productionOrder/getCompletedWordOrder`, params, {
    dataType: "json",
  });
};
/** 吹膜领取工单 */
export const getDeviceProOrderBatchListForReceive = (params) => {
  return axios.post(`${rootApi}/getDeviceProOrderBatchListForReceive`, params);
};
/** 普通领取工单 */
// 印刷待领取工单
export const getDeviceProOrderBatchListForReceive2 = (params) => {
  return axios.post(`${rootApi}/getDeviceProOrderBatchListForReceive2`, params, { dataType: "json" });
};
// 普通已领取工单
export const normalStationCheckedBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/normalStationCheckedBatch`,
    params
  );
};
// 压花已领取工单
export const embossStationChecked = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/embossStationChecked`,
    params
  );
};
// 压花领单获取
export const searchStationProductionOrder = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/searchStationProductionOrder`,
    params,{ dataType: "json" }
  );
};
// 印刷已领取工单
export const printStationCheckedBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationCheckedBatch`,
    params
  );
};
// 覆膜统计
export const getMaterielStatistics = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/getMaterielStatistics `,
    params,{ dataType: "json" }
  );
};
// 普通印刷 获取所有普通印刷暂停数据
export const getPauseOrder = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/getPauseOrder `,
    params,{ dataType: "json" }
  );
};
/** 普通完成 */
export const normalStationCheckoutBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/normalStationCheckoutBatch`,
    params
  );
};
/** 压花完成 */
export const embossingStationCheckoutBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/embossingStationCheckoutBatch`,
    params
  );
};
/** 报工 */
export const directlyReportForPrint = (params) => {
  return axios.post(
    `/api_v2/production/workOrder/directlyReportForPrint`,
    params,
  );
};
/** 普通取消 */
export const normalStationCancelBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/normalStationCancelBatch`,
    params
  );
};
/** 普通暂停 */
export const normalStationPauseOrder = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/normalStationPauseOrder`,
    params
  );
};
/** 制袋报工 */
export const bagMakingReport = (params) => {
  return axios.post(
    `/api_v2/production/bagMaking/reReport`,
    params,{ dataType: "json" }
  );
};
/** 制袋取消 */
export const bagMakingCancel = (params) => {
  return axios.post(
    `/api_v2/production/bagMaking/cancel?deviceInfoId=${params}`
  );
};
/** 制袋暂停 */
export const bagMakingPause = (params) => {
  return axios.post(
    `/api_v2/production/bagMaking/pause?deviceInfoId=${params}`
  );
};
/** 制袋重新开始 */
export const bagMakingRestart = (processFlowOrderId,deviceInfoId) => {
  return axios.post(
    `/api_v2/production/bagMaking/restart?processFlowOrderId=${processFlowOrderId}&deviceInfoId=${deviceInfoId}`
  );
};
/** 印刷领取 */
export const printStationCheckBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationCheckBatch`,
    params
  );
};
/** 印刷取消 */
export const printStationCancelBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationCancelBatch`,
    params
  );
};
/** 印刷暂停 */
export const printStationPauseOrder = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationPauseOrder`,
    params
  );
};
/** 印刷重新开工 */
export const pintStationRestartWork = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/pintStationRestartWork`,
    params
  );
};
/** 压花重新开工 */
export const embossStationRestartWork = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/embossStationRestartWork`,
    params
  );
};
/** 印刷扫码 */
export const printStationBeforeReceive = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationBeforeReceive`,
    params
  );
};
/** 印刷完成*/
export const printStationCheckoutBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationCheckoutBatch`,
    params
  );
};
/** 通过制令单获取膜卷，印刷工序使用膜卷 */
export const getMembraneByProductionTaskId = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/getMembraneByProductionTaskId`,
    params
  );
};
/** 通过订单获取膜卷，覆膜，压花抽边工序使用 膜卷*/
export const StationReportRecord = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/StationReportRecordByOrderId`,
    params
  );
};
/** 压花撤销 */
export const reportRecordDelete = (params) => {
  return axios.post(
    `/api_v2/production/reportRecord/delete `,
    params
  );
};
/** 获取产品信息 */
export const getDeviceWorkOrder = (params) => {
  return axios.post(`${rootApi}/getDeviceWorkOrder`, params);
};
/** 开工 */
export const StartWorkingbegin = (params) => {
  return axios.post(`${rootApi}/begin`, params);
};
/** 压花开工 */
export const edgePullingAndEmbossingStationCheckBatch = (params) => {
  return axios.post(`/api_v2/production/productionOrder/edgePullingAndEmbossingStationCheckBatch`, params);
};
/** 暂停 */
export const StartWorkingpause = (params) => {
  return axios.post(`${rootApi}/pause`, params);
};
/** 普通工单接口 */
export const getProductionOrder = (params) => {
  return axios.get(`/api_v2/production/workOrder/searchWorkOrder`, {
    params,
  });
};
/** 生产工单改进列表 */
export const workOrderPageByStatus = (params) => {
  return axios.post(
    `/api_v2/production/workOrder/workOrderPageByStatus`,
    params,
    { dataType: "json" }
  );
};
/** 工艺说明 */
export const getProcessMessage = (params) => {
  return axios.post(`/api_v2/production/workOrder/getProcessMessage`, params);
};
/** 印刷工艺说明 */
export const printStationProcessMessage = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/printStationProcessMessage`,
    params
  );
};
/** 通过订单获取工艺详情 */
export const stationProcessMessage = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/stationProcessMessage`,
    params
  );
};
/** 后道工序 */
export const nextProcess = (params) => {
  return axios.post(`/api_v2/production/workOrder/nextProcess`, params);
};
/** 同订单批次 */
export const getProOrderBatch = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/getProOrderBatch`,
    params
  );
};
/** 获取设备*/
export const deviceInfogetList = (params) => {
  return axios.get(`/api_v2/deviceInfo/getListByStation`, params);
};
/** 获取设备*/
export const deviceInfoGetList = (params) => {
  return axios.get(`/api_v2/deviceInfo/getList`, params);
};
/** 分配 */
export const workOrderTransfer = (params) => {
  return axios.post(`/api_v2/production/workOrder/workOrderTransfer`, params);
};
/** 获取所有丹业文档 */
export const getOrderDocumentList = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/getOrderDocumentList`,
    params
  );
};
/** 待分配工单 */
export const bagMakingStationWorkOrder = (params) => {
  return axios.post(
    `/api_v2/production/workOrder/bagMakingStationWorkOrder`,
    params,
    {
      dataType: "json",
    }
  );
};
/** 制袋工序 */
export const bagMakingWorkOrder = (params) => {
  return axios.post(`/api_v2/production/workOrder/bagMakingWorkOrder`, params, {
    dataType: "json",
  });
};
/** 制袋工序当前 */
export const bagMakingReceived = (params) => {
  return axios.get(`/api_v2/production/bagMaking/received?deviceInfoId=${params}`);
};
/** 制袋暂停 */
export const getPauseOrderByDevice = (params) => {
  return axios.post(`/api_v2/production/bagMaking/getPauseOrderByDevice`,params, {
    dataType: "json",
  });
};
/** 获取所有丹业文档 */
export const getprintOrderPDF = (params) => {
  return axios.post(`/api_v2/production/reportRecord/printOrderPDF/${params}`);
};
/** 普通扫码显示信息 */
export const getcheckNum = (params) => {
  return axios.post(`/api_v2/production/reportRecord/checkNum/${params}`);
};
/** 制袋获取上个未完成 */
export const searchWorkOrder = (params) => {
  return axios.post(`/api_v2/production/bagMaking/searchWorkOrder?deviceInfoId=${params}`);
};
/** 制袋领取 */
export const scanReceive = (params) => {
  return axios.post(`/api_v2/production/bagMaking/scanReceive`, params, {
    dataType: "json",
  });
};
/** 普通扫码后确认 */
export const scanReportRecordConfirm = (params) => {
  return axios.post(
    `/api_v2/production/reportRecord/scanReportRecordConfirm`,
    params,
    {
      dataType: "json",
    }
  );
};
/** 吹膜扫码显示信息 */
export const getProOrderBatchForReceive = (params) => {
  return axios.post(
    `/api_v2/production/productionOrder/getProOrderBatchForReceive`,
    params
  );
};

/** 吹膜扫码后确认领取 */
export const receiveFromBatch = (params) => {
  return axios.post(`/api_v2/production/productionOrder/pickOrder`, params);
};
/** 普通领取 */
export const normalStationCheckBatch = (params) => {
  return axios.post(`/api_v2/production/productionOrder/normalStationCheckBatch`, params);
};
/**卷膜上料选择批次 */
export const getMatchMembrane = (params) => {
  return axios.get(
    `/api_v2/warehouse/goodsInfo/getMatchMembrane?productionTaskId=${params}`
  );
};
/**卷膜上料 */
export const useMembrane = (params) => {
  return axios.post(`/api_v2/warehouse/goodsInfo/useMembrane`, params, {
    dataType: "json",
  });
};
/**卷膜入库 */
export const membraneInWarehouse = (params) => {
  return axios.post(`/api_v2/warehouse/goodsInfo/membraneInWarehouse`, params, {
    dataType: "json",
  });
};
/**仓库的下拉选 */
export const searchWarehouseDataList = (params) => {
  return axios.get(
    `/api_v2/warehouse/goodsInfo/searchWarehouseDataList`,
    params
  );
};
/**吹膜报工 */
export const blowReport = (params) => {
  return axios.post(`/api_v2/production/workOrder/blowReport`, params, {
    dataType: "json",
  });
};
/**吹膜完工 */
export const taskComplete = (params) => {
  return axios.post(`/api_v2/production/task/complete `, params,);
};
/**批次 */
export const getListReportRecord = (params) => {
  return axios.get(
    `/api_v2/production/processFlowOrder/getList?productionTaskId=${params}`
  );
};

/**订单获取制令单 */
export const getListByProductionOrderId = (params) => {
  return axios.get(
    `/api_v2/production/productionOrder/getListByProductionOrderId?orderId=${params}`
  );
};
// 获取流转卡列表
export const getProcessFlowOrderList = (params) => {
  return axios.post(
    `/api_v2/production/processFlowOrder/getProcessFlowOrderList `,
    params,
    
  );
};
// 通过流转卡id获取流转卡的详细数据
export const getProcessFlowOrderVO = (params) => {
  return axios.get(
    `/api_v2/production/processFlowOrder/getProcessFlowOrderVO?id=${params}`
    
  );
};
// 通过流转卡id获取流转卡的详细数据
export const getNextBatchCode = () => {
  return axios.get(
    `/api_v2/production/processFlowOrder/getNextBatchCode`
    
  );
};
// 通过流转卡id获取流转卡的详细数据
export const splitMembrane = ( params) => {
  return axios.post(
    `/api_v2/production/processFlowOrder/splitMembrane `,
    params,{
      dataType: "json",
    }
    
  );
};
// 通过批次获取打印的id
export const getReportIdByBatch = (params) => {
  return axios.get(
    `/api_v2/production/reportRecord/getReportIdByBatch?batch=${params}`
  );
};
// 获取巡检任务分页列表，状态：0 未检验、1 检验完成。
export const inspectionPatrolTaskList = (params) => {
  return axios.get(
    `/api_v2/inspection/patrolTask/listByDevice`,{params}
  );
};
// 根据巡检任务 ID 获取任务详情和工序检验项。
export const inspectionPatrolTaskId = (params) => {
  return axios.get(
    `/api_v2/inspection/patrolTask/${params}`,
  );
};
// 提交巡检结果并上传现场图片附件。
export const inspectionPatrolTaskSubmitWithFiles = (params) => {
  return axios.post(
    `/api_v2/inspection/patrolTask/submitWithFiles`, params,
  );
};
// 暂存巡检结果并上传现场图片附件。
export const itemporarySaveWithFiles = (params) => {
  return axios.post(
    `/api_v2/inspection/patrolTask/temporarySaveWithFiles`, params,
  );
};
// 撤销已完成的巡检任务，传入任务 ID。
export const patrolTaskRevoke = (params) => {
  return axios.post(
    `/api_v2/inspection/patrolTask/revoke/${params}`,
  );
};
// 获取相同型号的投诉
export const orderModel= (params) => {
  return axios.get(
    `/api_v2/inspection/customerComplaint/orderModel/${params}`,
  );
};
// 获取客户的全部投诉
export const orderCustomer= (params) => {
  return axios.get(
    `/api_v2/inspection/customerComplaint/orderCustomer/${params}`,
  );
};
// 质检扫码
export const patrolTaskScan= (params) => {
  return axios.get(
    `/api_v2/inspection/patrolTask/scan/${params}`,
  );
};
// 订单
export const dataAuthOrders  = (params) => {
  return axios.get(
    `/api_v2/client/dataAuth/orders`,params
  );
};
// 详情
export const dataAuthOrdersId  = (params) => {
  return axios.get(
    `/api_v2/client/dataAuth/orders/${params}` );
};